import { Button as BaseButton } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import classNames from 'classnames';
import React from 'react';
import styles from './index.module.less';

const Button: React.FC<ButtonProps> = ({ className, ...rest }) => (
  <BaseButton {...rest} className={classNames(styles.button, className)} />
);

export default Button;
